import './style.scss'

import clsx from 'clsx'
import { useAppSelector } from 'shared/hooks'

import { selectors } from '../../slice'

export function Notification() {
	const status = useAppSelector(selectors.status)
	const text = useAppSelector(selectors.text)
	const isError = useAppSelector(selectors.error)

	return status ? (
		<div
			className={clsx('notification', {
				error: isError
			})}
		>
			{text}
		</div>
	) : null
}
